export const loadTempState = () => {
    try {
        const serializedState = localStorage.getItem('state');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const saveTempState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('state', serializedState);
    } catch (err) {
        return undefined;
    }
};

export const deleteTempStorageState = () => {
    localStorage.removeItem('state');
};

export const saveCartState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('cart', serializedState);
    } catch (err) {
        return undefined;
    }
};

export const loadCartState = () => {
    try {
        const serializedState = localStorage.getItem('cart');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const clearCartState = () => {
    try {
        localStorage.setItem('cart', null);
    } catch (err) {
        return undefined;
    }
};

export const savePaymentState = (state) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('payment', serializedState);
    } catch (err) {
        return undefined;
    }
};

export const loadPaymentState = () => {
    try {
        const serializedState = localStorage.getItem('payment');
        if (serializedState === null) {
            return undefined;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return undefined;
    }
};

export const clearPaymentState = () => {
    try {
        localStorage.setItem('payment', null);
    } catch (err) {
        return undefined;
    }
};

export const setMapSettings = (settings: { baseLayer: string; hiddenOverlays: string[] }): void => {
    try {
        localStorage.setItem('map-view-settings', JSON.stringify(settings));
    } catch (err) {
        return undefined;
    }
};

export const getMapSettings = (): { baseLayer: string; hiddenOverlays: string[] } | undefined => {
    try {
        const settings = localStorage.getItem('map-view-settings');
        if (settings === null) {
            return undefined;
        }
        return JSON.parse(settings);
    } catch (err) {
        return undefined;
    }
};
